var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticClass: "_component-icon-svg",
      attrs: {
        width: "12",
        height: "9",
        viewBox: "0 0 12 9",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      on: {
        click: function($event) {
          return _vm.$emit("click")
        }
      }
    },
    [
      _c("path", {
        style: _vm.componentStyle,
        attrs: { d: "M1 3.5L4.66667 7L11 1", "stroke-width": "2" }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }